import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function ReturnToSearchButton() {
  return (
    <IconButton href="/lk_legal_docs_app">
      <ArrowBackIcon fontSize="small" />
    </IconButton>
  );
}
